export default {
      id: "map__car_type_flatbed-usage",
      viewBox: "0 0 15 37",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_flatbed",
      toString: function () {
        return this.url;
      }
    }